import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';

import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService, SharedService } from '@app/core';

@Injectable({
  providedIn: 'root'
})
export class DemoService {
  constructor(private http: HttpClient,
    private appGlobals: AppGlobals,
    private authService: AuthService,
    private sharedService: SharedService,
    private entityService: EntityService) {
  }

  login(mobile: string) {
    const credentials = this.sharedService.encrypt(JSON.stringify({ mobile }));

    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}demo-login`, { credentials });
  }

  verifyOtp(otp: string, token: string) {
    const credentials = this.sharedService.encrypt(JSON.stringify({ otp }));

    return this.http.post<any>(`${this.appGlobals.apiUrl.authentication}verify-demo-otp`, { credentials }, {
      headers: { 'Authorization': `Bearer ${token}` }
    }).pipe(
      map(res => this.authService.authenticate({ ...res, user: JSON.parse(this.sharedService.decrypt(res.user)), expiry: new Date(res.expiry) })),
      switchMap(() => this.authService.user.isOwner && this.authService.user.isOnboarded ? this.entityService.fetchEntities() : of(null)),
      tap(entities => entities ? this.entityService.setInitialEntities(entities, this.authService.user) : of(null))
    );
  }
}